<template>
  <section class="block-content mb-5 overflow-hidden" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
    <div class="container-fluid my-md-5 py-md-5 mx-auto text-lg-center">
      <h2>Unsere Leistungen</h2>
      <div class="row g-5 align-items-start" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
        <div v-for="service in services" :key="service.id" class="col-12 col-lg-4 mb-4 mb-md-0 order-md-2 service-item position-relative">
          <div class="img-container mb-4">
            <img v-if="service.image" width="640" height="360" class="img-fluid" :src="generateThumbnail(service.image.data.asset_url,640,360,60,'contain')" :title="service.title" />
            <img v-else width="640" height="360" class="img-fluid" :src="placeholder800" />
          </div>
          <h3>{{service.title}}</h3>
          <article class="d-content" v-html="service.excerpt"></article>
            <router-link :to="{name: 'services.single', params: {id : service.slug}}" class="btn btn-outline-ito hover-red animated-arrow stretched-link mt-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
            </svg>
            <span v-if="service.cta_button_text">{{service.cta_button_text}}</span>
            <span v-else>weitere Informationen </span>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import axios from 'axios'

export default {
  name: 'ServicesContent',
  data: function () {
    return {
      services: {},
      placeholder800: require('@/assets/gfx/placeholder_800x450.jpg')
    }
  },
  async beforeMount () {
    await axios.get('/services?fields=title,slug,cta_button_text,excerpt,image.*')
      .then(response => (this.services = response.data.data))
  },
  methods: {
    generateThumbnail (asset, w, h, q, f) {
      return 'https://cdn.ito-consult.de' + asset + '?w=' + w + '&h=' + h + '&q=' + q + '&f=' + f
    }
  }
}
</script>

<style lang="less" scoped>
  .container-fluid {max-width: 1600px;}
 .service-item {
    img {
      filter: grayscale(100%); transition: all 300ms;
    }
    &:hover img {filter: grayscale(0%);}

    .d-content {text-align:left;}
 }
</style>
